import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import arrowTopKYC from 'common/images/arrowTopKYC.svg';
import { withTheme } from 'common/styling/theme';
import { PageContentPreloader } from 'common/components';

import { getUserShuftiProReport } from 'backoffice/users/_redux';

import { staticStyles, getDynamicStyles } from './style';

const UserShuftiProDocuments = ({ userId, theme }) => {
  const dispatch = useDispatch();
  const { shuftiProReportUrl, shuftiProReportIsLoaded } = useSelector(state => state.backoffice.users);

  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  const [openBlock, setOpenBlock] = useState(false);

  const handleBlockToggle = () => {
    setOpenBlock(isOpen => !isOpen);
  };

  useEffect(() => {
    if (openBlock && !shuftiProReportUrl) {
      dispatch(getUserShuftiProReport.request({ userId, shouldDownload: false }));
    }
  }, [openBlock, shuftiProReportUrl]);

  return (
    <div className="UserShuftiProDocuments">
      {/* eslint-disable */}
      <div
        className={classNames('UserShuftiProDocuments__open-close', {
          'UserShuftiProDocuments__open-close--close': !openBlock,
        })}
        onClick={handleBlockToggle}
      />
      {/* eslint-enable */}
      <FormattedMessage id="justShuftiProDocuments">
        {txt => (
          <h2
            className={classNames('UserShuftiProDocuments__title', {
              'UserShuftiProDocuments__title--hide': !openBlock,
            })}>
            {txt}
          </h2>
        )}
      </FormattedMessage>
      {/* eslint-disable */}
      <img
        className={classNames('UserShuftiProDocuments__arrowTopKYC', {
          'UserShuftiProDocuments__arrowTopKYC--hide': !openBlock,
        })}
        src={arrowTopKYC}
        alt="arrowTopKYC"
        onClick={handleBlockToggle}
      />
      {/* eslint-enable */}
      <div
        className={classNames('UserShuftiProDocuments__documents-wrapper', {
          'UserShuftiProDocuments__documents-wrapper--hide': !openBlock,
        })}>
        <PageContentPreloader ready={shuftiProReportIsLoaded} type="bigBlock">
          <iframe
            title="shuftiproreport-iframe"
            src={shuftiProReportUrl}
            width="100%"
            height="800px"
            style={{ border: 'none' }}
          />
        </PageContentPreloader>
      </div>
      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
    </div>
  );
};

UserShuftiProDocuments.propTypes = {
  userId: PropTypes.number.isRequired,
  theme: PropTypes.object,
};

UserShuftiProDocuments.defaultProps = {
  theme: {},
};

export default withTheme()(UserShuftiProDocuments);
